import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from 'Modules/contacard/moduleBreadcrumbs';

const breadcrumps = [
  ...moduleBreadcrumbs,
  {
    text: 'Listar modelos',
    disabled: true,
  },
];

export default [
  ...buildCrudRoutes({
    baseName: 'model',
    basePath: 'model',
    moduleActive: 'contacard',
    subModuleActive: 'terminal',
    card: {
      title: 'Modelo de terminal',
      icon: 'home',
    },
    baseBreadcrumbs: breadcrumps,
    listRoute: {
      navigateBackRoute: 'contacard.submodules.list',
      pageTitle: 'Modelos',
      pageContent: () => import('Modules/contacard/terminal/model/PosModelCrudList.vue'),
      searchOptions: { label: 'Buscar modelo', searchAttribute: 'search' },
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
    },
    newRoute: {
      component: () => import('App/modules/contacard/terminal/model/PosModelForm.vue'),
      breadcrumbs: [
        {
          text: 'Adicionar modelo',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('App/modules/contacard/terminal/model/PosModelForm.vue'),
      breadcrumbs: [
        {
          text: 'Editar modelo',
          disabled: true,
        },
      ],
    },
  }),
];
